import { Box, Grid, CircularProgress, Button, Dialog, DialogTitle, 
    DialogContent, DialogContentText, DialogActions } from "@mui/material";
import { green, red } from "@mui/material/colors";
//import { useCalendarState } from "@mui/x-date-pickers/internals";
import React, { useEffect, useState } from "react";
import AccessLocalStorage from "../../services/localStorage";
import {getApiUrl} from "../../services/api_service"
import MyTimer from "../shared/mytimer";
import { useLocation, useHistory } from 'react-router-dom';
import { useAuth } from "../../contexts/AuthContext";

export default function AcceptAndValidate(props) {
    const timerseconds = 60;
    const time = new Date();
    time.setSeconds(time.getSeconds() + timerseconds);
    const [otp, setOTP] = useState("");
    const [validationFailCount, setValidationFailCount] = useState(0);
    const [timer, setTimer] = useState(time);
    const [pagestatus, setStatus] = useState({ success: '', error: '', showModal: false });
    const [loading, setLoading] = useState(false);
    const [allowResend, setAllowResend] = useState(false);
    const ls = new AccessLocalStorage();
    const location = useLocation();
    const history = useHistory();
    let auth = useAuth();
    //let { setAuthData } = useContext(AuthContext);

    const acceptAndValidateOTP = () => {
        setLoading(true);
        fetch(getApiUrl() + "/Account/AcceptAndValidate", {
            method: "post", headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ id: props.id, otp })
        }).then(resp => {
            if (resp.status === 200) {
                resp.json().then(data => {
                    //console.log(data);
                    setLoading(false);
                    auth.setAuthData(data);
                    setStatus({ success: "Invitation accepted and login successfull.", error: '', showModal: true });
                    history.push('/');
                });
            } else {
                setLoading(false);
                // let v = validationFailCount;
                // v++;
                // setValidationFailCount(v);
                resp.json().then(data => {
                    setStatus({ success: '', error: data.error, showModal: false });
                })

            }
        }).catch(err => {
            setLoading(false);
            setStatus({ success: '', error: 'Unable to contact server. Check your internet connection.', showModal: false });
        });
    }

    const sendingOTPAllowed = () => {
        if (ls.getOTPSentCount() >= 5) {
            let b = ls.hoursPassedSinceLastOTPSent() >= 0 && ls.hoursPassedSinceLastOTPSent() <= 5;
            return !b;
        }
        return true;
    }

    const resendOTP = () => {
        if (!sendingOTPAllowed()) {
            setStatus({ success: '', error: 'You have exhausted all attempts, please try after two hours.', showModal: true });
            return;
        }

        setLoading(true);
        setStatus({ success: '', error: '', showModal: false });
        fetch(getApiUrl() + "/Account/ResendOTP?email=" + props.email, { method: "get" }).then(resp => {
            if (resp.status === 200) {
                setStatus({ success: 'A six digit passcode has been sent to your registered phone number and email.', error: '', showModal: true });
                setLoading(false);
                setAllowResend(false);
                let t = new Date();
                t.setSeconds(t.getSeconds() + timerseconds);
                setTimer(t);
                ls.setOTPSentCount(ls.getOTPSentCount() + 1);
            } else {
                resp.json().then(data => {
                    setStatus({ success: '', error: data.error, showModal: true });
                    setLoading(false);
                });
            }
        }).catch(err => {
            setLoading(false);
            setStatus({ success: '', error: 'Unable to contact server. Check your internet connection.', showModal: false });
        });
    }


    const renderError = () => {
        if (pagestatus.error !== "") {
            if (pagestatus.showModal)
                return <Dialog
                    open={pagestatus.error !== ""}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">
                        {"Warning"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                        <div style={{
                color: "#545454",
                fontSize: "1.125em",
                fontWeight: "400",
                lineHeight: "normal",
                textAlign: "center",
                wordWrap: "break-word",
                wordBreak: "break-word", maxWidth: "400px", marginTop: "20px"
              }}>
                            {pagestatus.error}</div>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button type="button" style={{
                marginBottom: "20px", backgroundColor: "#4bc0a9", color: "#ffffff", borderRadius: "9px",
                height: "41px"
              }} onClick={() => { setStatus({ success: pagestatus.success, error: '', showModal: false }); }} autoFocus>
                            Ok
                        </Button>
                    </DialogActions>
                </Dialog>;
            else
                return <Box m={1} textAlign={"center"} color={red}>{pagestatus.error}</Box>;
        }
        else return null;
    }

    const renderSuccess = () => {
        if (pagestatus.success !== "") {
            if (pagestatus.showModal)
                return <Dialog
                    open={pagestatus.success !== ""}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">
                        
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                        <div style={{
                color: "#545454",
                fontSize: "1.125em",
                fontWeight: "400",
                lineHeight: "normal",
                textAlign: "center",
                wordWrap: "break-word",
                wordBreak: "break-word", maxWidth: "400px", marginTop: "20px"
              }}>
                            {pagestatus.success}</div>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions style={{ justifyContent: "center" }}>
                        <Button type="button" style={{
                marginBottom: "20px", backgroundColor: "#4bc0a9", color: "#ffffff", borderRadius: "9px",
                height: "41px"
              }} onClick={() => { setStatus({ success: '', error: pagestatus.error, showModal: false }); }} autoFocus>
                            Ok
                        </Button>
                    </DialogActions>
                </Dialog>;
            else
                return <Box m={1} textAlign={"center"} color={green}>{pagestatus.success}</Box>;
        }
        else return null;
    }

    const padTo2Digits = (num) => {
        return num.toString().padStart(2, '0');
    }

    const renderTimer = () => {
        if (timer != null) {
            return <Box textAlign={"center"} p={2} pt={0}>Resend code in <span style={{
                backgroundColor: "#6C757D", borderRadius: "5px", color: "#ffffff", fontWeight: "bold", padding: "3px"
            }}><MyTimer expiryTimestamp={timer} onExpired={() => {
                setAllowResend(true);
                setTimer(null);
            }} /></span></Box>;
        } else return renderResentLink();
    }

    const renderResentLink = () => {
        if (!allowResend) return null;

        if (!sendingOTPAllowed()) {
            return <Box mb={3} p={2} style={{ textAlign: "center" }}>You have exhausted all attempts, try after 2 hours.</Box>;
        }

        return <Box mb={3} p={2} style={{ textAlign: "center" }}><a href="javascript:void(0);" style={{ color: "#4bc0a9" }} onClick={resendOTP}>Resend OTP</a></Box>;
    }

    return (<Box sx={{ bgcolor: "background.main" }}>
        <Grid container >
            {props.width >= 902 && <Grid item md={6} style={{ minHeight: "100vh" }}></Grid>}
            <Grid style={{ background: "#ffffff", minHeight: "100vh" }} item md={6}>
                <Box p={2} py={5} textAlign="center">
                    <img src='../Logo_Option_1.svg' alt='logo' ></img>
                </Box>
                <h3 style={{ fontWeight: "400", textAlign: "center", fontSize: "1.1rem" }} p={3}>A six digit passcode has been sent to your registered mobile number.</h3>
                <Box style={{ fontWeight: "400", textAlign: "center", margin: "20px 0px", fontSize: "1.1rem" }}>Please enter the code below</Box>

                <form onSubmit={(e) => { e.preventDefault(); }}>
                    <Box pt={2} style={{ margin: "0 auto", width: "400px" }}>
                        <input type="text"
                            title={""}
                            required
                            maxLength={6}
                            value={otp} style={{
                                border: "1px solid #989898",
                                borderRadius: "9px", fontSize: "2rem", width: "100%", textAlign: "center", padding: "8px", backgroundColor: "#f9f9f9"
                            }}
                            onChange={(e) => { setOTP(e.target.value); }}
                        />
                    </Box>
                    {renderError()}
                    {renderSuccess()}
                    <Box style={{ textAlign: "center", padding:"20px 0px", margin: "0 auto", width: "400px" }}>
                        <Button type="submit" onClick={acceptAndValidateOTP} variant={otp.length === 6 ? "contained" : "outlined"}
                            disabled={otp.length < 6} color="primary" style={{
                                color: "#fff",
                                background: "#4bc0a9",
                                borderColor: "#4bc0a9",
                                borderRadius: "9px",
                                minHeight: "46px",
                                boxShadow: "none "
                            }}>
                            {loading ? <CircularProgress color="inherit" /> : "Validate"}
                        </Button>
                    </Box>
                    
                    <div style={{ marginTop: "35px", fontSize:"16px" }}>
                        {renderTimer()}
                    </div>
                    <div style={{ marginTop: "20px", marginRight:"20px", textAlign:"right", fontSize:"16px" }}>
                        <span style={{color: "#222222"}}>Attempts left:</span> <span style={{ borderRadius:"5px", padding:"3px 5px", color: "#fff",
                                background: "#4bc0a9"}}>{5 - ls.getOTPSentCount()}</span>
                    </div>
                </form>
            </Grid>
        </Grid>
    </Box>);
}